import React from "react";
import {
  Navigate,
  useLocation
} from "react-router-dom";

const AdminProtectedRoute = ({
  children
}) => {

  const location = useLocation();

  const token =
    sessionStorage.getItem("token");

  const idUser =
    sessionStorage.getItem("id_user");

  let user = null;

  try {
    const storedUser =
      sessionStorage.getItem("user");

    user = storedUser
      ? JSON.parse(storedUser)
      : null;

  } catch (error) {
    console.error(
      "ADMIN USER PARSE ERROR:",
      error
    );
  }

  // Pas connecté
  if (!token || !idUser || !user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname
        }}
      />
    );
  }

  // Connecté mais pas admin
  if (Number(user.isAdmin) !== 1) {
    return (
      <Navigate
        to="/home"
        replace
      />
    );
  }

  return children;
};

export default AdminProtectedRoute;